import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/49/thumb-landscape.jpg"


const Post49 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">HERMES／エヴリンⅡPM／29 x30 x8cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>HERMES（エルメス）で長く人気のショルダーバッグEvelyne（エヴリン）。名前は知らなくとも、一度は目にしたことがあるバッグではないでしょうか？<br></br>今回はEvelyne（エヴリン）の４つのサイズ展開、デザインの違いなどを紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.Evelyne（エヴリン）とは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.Evelyne（エヴリン）の4つのサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.Evelyne（エヴリン）の年式によるデザインの違い</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.Evelyne（エヴリン）の持ち方</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.まとめ</ScrollLink>
        </p> 
      </div>               
      <div name="sec1" className="text-two-cloumn">
        <h2>1.Evelyne（エヴリン）とは？</h2>
        <p>大きくパンチングされたHERMES（エルメス）の「H」がとても印象的なEvelyne（エヴリン）は、当時の馬具部門のディレクター『エブリン・ベルトラン』の手によって1978年に登場したバッグ。<br></br>登場から40年以上たった現在も、ジェンダーレスで人気のバッグです。
        </p>
      </div> 
      <div name="sec2" className="text-max-width">
        <h2>2.Evelyne（エヴリン）の4つのサイズ展開</h2> 
        <h2>■Evelyne（エヴリン）TPM /15x18x5cm(幅x高さxマチ)</h2>
        <p>
          一番小さいサイズのTPM。最近のミニサイズバッグのトレンドの流れもあり、ますます人気が高まっているサイズ。
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/49/1.jpg" alt="HERMES（エルメス）の定番人気♡Evelyne（エヴリン）"/>
      </figure>      
      <span className="text-center">カラーを選ぶとコーデのポイントになってかわいい♡</span>
      <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
       HERMESのバッグを見る
      </Link>
      <div className="text-max-width">
        <h2>■Evelyne（エヴリン）PM /28x28x7cm(幅x高さxマチ)</h2>
        <p>
          女性にいちばん人気のサイズ。小柄な方も持ちやすい、程よいサイズ感でありながら長財布も収納可能！
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/49/2.jpg"/>
      </figure>
      <div className="text-max-width">
        <h2>■Evelyne（エヴリン）GM /32x29x8cm(幅x高さxマチ)</h2>
        <p>
          PMよりひと回り大きいGMは、A4サイズも収納可能。メンズにも人気が高いサイズです。<br></br>一見PMとGMのサイズ感はそこまで変わらないので、分かりやすいように比較しております。
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/49/3.jpg"/>
      </figure>
      <span className="text-center">写真左： GM　右：PM</span>
       <figure>
        <StaticImage src="../../images/posts/49/4.jpg"/>
      </figure>
      <p>
        GMを実際に持ってみるとPMより少し大きくなる印象です。
      </p>
      <div className="text-max-width">
        <h2>■Evelyne（エヴリン）TGM /39x38x8cm(幅x高さxマチ)</h2>
        <figure className="img-small">
          <StaticImage src="../../images/posts/49/5.png"/>
        </figure>        
        <p>
          TGMは、かなり大きなサイズです。どちらかというと、身長の高い方やメンズにおすすめのバッグですね。
        </p>
      </div> 
      <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
       HERMESのバッグを見る
      </Link>                                                          
      <div name="sec3" className="text-max-width">
        <h2>3.Evelyne（エヴリン）の年式によるデザインの違い</h2>
        <p>登場から長い年月を迎えるEvelyne（エヴリン）はこれまで3回の仕様変更を行っています。それぞれのモデルの違いをご紹介します。</p>
        <h2>■ Ⅰ（アン）</h2>
        <p>1978年に登場したEvelyne（エヴリン）の中でも一番シンプルですっきりとした見た目が特徴の Ⅰ（アン）。外側ポケットは無く、内ポケットがついているタイプです。</p>
      </div>      
      <figure>
        <StaticImage src="../../images/posts/49/6.jpg"/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/49/7.jpg"/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/49/8.jpg"/>
      </figure>                          
      <div className="text-max-width">
        <h2>■ Ⅱ（ドゥ）</h2>
        <p>2005年ごろに登場したEvelyne（エヴリン）Ⅱ（ドゥ）。外側にポケットが付き、より使いやすいデザインへ変更されています。内ポケットはなくなり、中はよりシンプルなデザインへ。</p> 
      </div>             
      <figure>
        <StaticImage src="../../images/posts/49/9.jpg"/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/49/10.jpg"/>
      </figure>
      <figure>
        <StaticImage src="../../images/posts/49/11.jpg"/>
      </figure> 
      <div className="text-max-width">
        <h2>■ Ⅲ（トロワ）</h2>
        <p>2014年より現行のモデル。Ⅱ（ドゥ）のデザインに、これまでできなかったショルダーストラップの長さ調節が可能になりました。</p>
      </div>             
      <figure className="img-small">
        <StaticImage src="../../images/posts/49/12.jpg"/>
      </figure>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/49/13.jpg"/>
        </figure> 
        <figure className="img-small">
          <StaticImage src="../../images/posts/49/14.jpg"/>
        </figure>
      </div>
      <div name="sec4" className="text-two-cloumn">
        <h2>4.Evelyne（エヴリン）の<br className="pc"></br>持ち方</h2>
        <p>正面に大きくパンチングされた「H」のマークが正面だと思っていませんか？本来は、「H」のマークが裏側とのこと。<br></br>Evelyne（エヴリン）は元々、馬のブラシなどの道具を運ぶために作られたバッグ。パンチングはバッグ内部に湿気がこもらないよう、通気口の役割を果たしており「風通し」を良くするための実用的なものだったのです。<br></br>現在は、Evelyne（エヴリン）と言えば、パンチングのイメージが高いのでその日のコーディネートに合わせてどちらを前に持っても良いですね！</p>
      </div>                                                   
      <div name="sec5" className="text-two-cloumn">
        <h2>5.まとめ</h2>
        <p>いかがでしたでしょうか？Evelyne（エヴリン）は1つ1つ職人さんが時間をかけて生産しており、非常に人気なバッグです。<br></br>ぜひ一度、試してみませんか？</p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
       HERMESのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post49

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 49}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
